export default {
  setSuperUserWorkspaces(state, payload) {
    state.superUserWorkspaces = payload;
  },
  setSuperUserWorkspaceActiveSources(state, payload) {
    state.superUserWorkspaceActiveSources = payload;
  },
  setSuperUserWorkspaceOwners(state, payload) {
    state.superUserWorkspaceOwners = payload;
  },
  setSuperUserWorkspaceDetail(state, payload) {
    state.superUserWorkspaceDetail = payload;
  },
};
